import {Endereco} from './endereco.model';
import {Telefone} from './telefone.model';

export class PessoaFisica {

  id: number;
  idUnico: number;
  nome: string;
  cpf: string;
  telefones: Telefone[];
  enderecos: Endereco[];
  ocupacaoPrincipal: {id: number, nome: string};
  constructor(init?: Partial<PessoaFisica>) {
    Object.assign(this, init);
  }

}
